/**
 * 2007-2019 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Open Software License (OSL 3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * http://opensource.org/licenses/osl-3.0.php
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2019 PrestaShop SA
 * @license   http://opensource.org/licenses/osl-3.0.php Open Software License (OSL 3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
// import $ from 'expose-loader?$!expose-loader?jQuery!jquery';
import 'expose-loader?Tether!tether';
import 'bootstrap/dist/js/bootstrap.min';
import 'bootstrap-touchspin';

// import '../css/theme';
import './responsive';
import './checkout';
import './customer';
import './listing';
import './product';
import './cart';

import DropDown from './components/drop-down';
import Form from './components/form';
import MainMenu from './components/main-menu';
// import ProductMinitature from './components/product-miniature';
import ProductSelect from './components/product-select';

import prestashop from 'prestashop';
import EventEmitter from 'events';

import './lib/bootstrap-filestyle.min';
import './lib/jquery.bxslider.min';
import './lib/jquery.cookie';
import './lib/jquery.unveil';
import './lib/jquery.viewportchecker.min';
// import './lib/jquery.swipebox.min';

import './components/block-cart';

// "inherit" EventEmitter
for (var i in EventEmitter.prototype) {
  prestashop[i] = EventEmitter.prototype[i];
}

var body = document.getElementsByTagName('body')[0];
var html = document.getElementsByTagName('html')[0];
var prevScroll = 0;
var prevPrevScroll = 0;

// if page is already scrolled on load
if (window.scrollY > 0) {
  body.classList.add('js-scroll-down');
  body.classList.add('js-scrolled');
}
// Detect if scrolling up or down
window.addEventListener('scroll', function() {
  let windowY = (window.scrollY) ? window.scrollY : window.pageYOffset;
  if (windowY > 0) {
    body.classList.add('js-scrolled');
    // console.log('windowY: ' + windowY + ', prevScroll:' + prevScroll + ', prevPrevScroll:' + prevPrevScroll);
    if (windowY < prevScroll) {
      // Scrolling UP
      body.classList.add('js-scroll-up');
      body.classList.remove('js-scroll-down');
    } else if (windowY > prevScroll) {
      // Scrolling DOWN
      body.classList.add('js-scroll-down');
      body.classList.remove('js-scroll-up');
    }
    if (windowY > window.innerHeight) {
      // scrolled more that window height
      body.classList.add('js-scrolled-100vh');
    } else {
      body.classList.remove('js-scrolled-100vh');
    }
  } else {
    body.classList.remove('js-scrolled');
  }
  prevPrevScroll = prevScroll;
  prevScroll = windowY; 
});

$(document).ready(() => {
  let dropDownEl = $('.js-dropdown');
  const form = new Form();
  let dropDown = new DropDown(dropDownEl);
  // let productMinitature = new ProductMinitature();
  let productSelect  = new ProductSelect();
  let mainMenu = new MainMenu();
  dropDown.init();
  form.init();
  mainMenu.init();
  // productMinitature.init();
  productSelect.init();
 /* $("#products").bind("DOMSubtreeModified", function() {
    productMinitature.init();
  });*/

  var sidebarHeight;
  var windowHeight;
  var scrollTop;

  // carousel product page
  if (!!$.prototype.bxSlider)
    /*$('.page-product #main .jq_carousel, .cross-selling .jq_carousel').bxSlider({
      minSlides: 3,
      maxSlides: 6,
      slideWidth: 200,
      slideMargin: 15,
      pager: false,
      nextText: '',
      prevText: '',
      moveSlides:1,
      infiniteLoop:false,
      hideControlOnEnd: true
    });*/

  $("img.lazy").unveil(200);

  // add class when element is visible in viewport for "loading" transitions
  $('.product_list_animation ul.products li, .product_list_animation .home-title, .product_list_animation li.vertical-blocks-blog').addClass('not-visible').viewportChecker({
      offset: 0,
      classToRemove: 'not-visible',
  });

  $('.address-item input:radio').change(function() {
    if (this.checked) {
      $(this).closest('.address-selector').find('.address-item.selected').removeClass('selected');
      $(this).closest('.address-item').addClass('selected');
    }
  });

  // sidebar always visible
  $(window).scroll(function() {
    sidebarHeight = $('#header').outerHeight();
    windowHeight = $(window).height();
    scrollTop = $(window).scrollTop();

    if(windowHeight > sidebarHeight) {
      $('#header').removeClass('fixed-bottom').addClass('fixed-top');
    } else {
      $('#header').removeClass('fixed-top').toggleClass('fixed-bottom', scrollTop + windowHeight > 20 + sidebarHeight);
    } 
  });
});
